import {
  Box,
  Button,
  HStack,
  Text,
  useDisclosure,
  VStack,
} from '@chakra-ui/react'
import { format, subMonths } from 'date-fns'
import React, { useCallback, useState } from 'react'
import { REPOSITORY } from '../../../../api/repository/Repository'
import CustomDatePicker from '../../../../components/CustomDatePicker/CustomDatePicker'
import Table from '../../../../components/Table/Table'
import { useLoadingContext } from '../../../../utils/hooks/Context/LoadingContext'
import { useRequestStatusContext } from '../../../../utils/hooks/Context/RequestStatusContext'
const columns = [
  {
    Header: 'Fecha y hora',
    accessor: 'FechaHora',
    type: 'dateH',
  },
  {
    Header: 'Tipo de movimiento',
    accessor: 'TipoMovimiento',
  },
  {
    Header: 'Monto',
    accessor: 'Monto',
  },
  {
    Header: 'RUT  comercio',
    accessor: 'RutComercio',
    type: 'dni',
  },
  {
    Header: 'Nombre del comercio',
    accessor: 'NombreComercio',
  },
  {
    Header: 'RUT Colaborador',
    accessor: 'RutUsuario',
    type: 'dni',
  },
  {
    Header: 'Nombre colaborador',
    accessor: 'NombreSocio',
  },
]
export default function CasinoReport() {
  const [data, setData] = useState([])
  const [filterData, setFilterData] = useState({})
  const [pagination, setPagination] = useState({ page: 1, totalPages: 0 })
  const {
    isOpen: dataFetched,
    onOpen: handleDataFetched,
    onClose: onDeleteDataFetched,
  } = useDisclosure({ defaultIsOpen: false })
  const { handleOpen: handleOpenLoading, handleClose: handleCLoseLoading } =
    useLoadingContext()

  const { handleOpen, handleSetTitle, handleChangeBody, handleClose } =
    useRequestStatusContext()

  const handleGetReport = async (onlyInfo, page = 1) => {
    handleOpenLoading()
    await REPOSITORY.wsEmpresa.reports
      .casinoReport(
        filterData.dDesde,
        filterData.dHasta,
        page,
        20,
        false,
        {
          'Content-Type': 'blob',
        },
        onlyInfo,
      )
      .then((response) => {
        if (!onlyInfo) {
          const url = URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', `Informe de consumo casino.xlsx`)
          document.body.appendChild(link)
          link.click()
          handleSetTitle('Reporte descargado con exito', 200)
          handleChangeBody(
            <Button variant="primary" onClick={handleClose}>
              Continuar
            </Button>,
          )
          handleOpen()
        } else {
          onDeleteDataFetched()
          handleDataFetched()
          setData(
            response.data.lDatos.map((el) => ({
              ...el,
              NombreSocio: `${el.NombreSocio} ${el.ApellidoPaternoSocio}`,
              FechaHora: `${el.Fecha.replaceAll('/', '-')} ${el.Hora}`,
            })),
            setPagination({
              page: response.data.nPagina,
              totalPages: response.data.nPaginasTotal,
            }),
          )
        }
        handleCLoseLoading()
      })
      .catch((error) => {
        handleCLoseLoading()
        handleSetTitle(
          'No se pudo crear el reporte. Intente alargando el rango de fechas, si el error persiste, contacte a soporte',
          error.response.status,
        )
        handleChangeBody(
          <Button variant="primary" onClick={handleClose}>
            {error.status === 200 ? 'Continuar' : 'Contactar a soporte ahora'}
          </Button>,
        )
        handleOpen()
      })
    handleCLoseLoading()
  }
  const handleGetReportPage = async (page) => {
    handleOpenLoading()
    handleGetReport(true, page)
  }

  const validateReport = ({ onlyInfo }) => {
    if (filterData.dDesde && filterData.dHasta) {
      handleGetReport(onlyInfo)
    } else {
      handleCLoseLoading()
      handleSetTitle('Se necesita una fecha de inicio y fecha final', 500)
      handleChangeBody(
        <Button variant="primary" onClick={handleClose}>
          Continuar
        </Button>,
      )
      handleOpen()
    }
  }
  const handleChangeFrom = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dDesde: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])

  const handleChangeTo = useCallback((date) => {
    setFilterData((prevState) => ({
      ...prevState,
      dHasta: date ? format(date, 'dd-MM-yyyy') : null,
    }))
  }, [])
  return (
    <VStack alignItems="flex-start" spacing="32px" w="100%">
      <HStack
        w="100%"
        alignItems="flex-end"
        h="32px"
        justifyContent="flex-start"
        spacing="16px"
      >
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Desde</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="140px">
            <CustomDatePicker
              maxDate={new Date()}
              defaultValue={subMonths(new Date(), 1)}
              onChange={handleChangeFrom}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <VStack alignItems="flex-start" justifyContent="flex-start">
          <Text variant="subtitle2">Hasta</Text>
          <Box border="1px solid #D7D7D7" maxW="150px" minW="140px" w="120px">
            <CustomDatePicker
              maxDate={new Date()}
              defaultValue={new Date()}
              onChange={handleChangeTo}
              placeholder="dd/mm/aaaa"
            />
          </Box>
        </VStack>
        <Box>
          <Button
            variant="primaryLight"
            onClick={() => validateReport({ onlyInfo: true })}
          >
            Ver Reporte
          </Button>
        </Box>
        <Box>
          <Button
            variant="white"
            border={'none'}
            onClick={() => validateReport({ onlyInfo: false })}
          >
            Descargar excel
          </Button>
        </Box>
      </HStack>
      {dataFetched && (
        <Box position="absolute" width="80%" left="10%">
          <Box width="100%" marginTop="32px">
            <Table
              data={data}
              columns={columns}
              withPagination
              paginationProps={{
                totalPages: pagination.totalPages,
                actualPage: pagination.page,
                handlePageChange: handleGetReportPage,
              }}
            />
          </Box>
        </Box>
      )}
    </VStack>
  )
}
